module.exports = __webpack_public_path__ + "static/media/keyword-reply.075671bc.png";